import { AxiosResponse } from 'axios';
import { useAxios } from '../../composables/axios';
import { Information } from './information.model';

const axios = useAxios();

export interface InformationService {
  Get: () => Promise<AxiosResponse<Information>>;
}

const Get = (): Promise<AxiosResponse<Information>> =>
  axios.Get<Information>('/api/informations');

export default { Get } as InformationService;
